import styled from 'styled-components';

// Borrowing lots of styles from the Zorse "Help" button itself:
// https://git.hubteam.com/HubSpot/Zorse/blob/237663e1d38d4c56daf66bba254c09f7544a8978/ZorseButtonUI/static/sass/zorse_shell.sass#L177-L185
const StyledOperationsHubOnboardingButton = styled.button.withConfig({
  displayName: "StyledOperationsHubOnboardingButton",
  componentId: "sc-1dvr2nn-0"
})(["background-color:", ";border-radius:20px 20px 2px 20px;box-shadow:0 5px 20px 0 rgba(12,73,84,0.2);cursor:pointer;display:block;font-size:14px;line-height:normal;color:#fff;padding:18px 24px 17px;transition:background-color 0.15s ease-out,box-shadow 0.15s ease-out;border-width:0;z-index:900;position:fixed;bottom:16px;pointer-events:all;&:hover{background-color:#ff9e6f;}&::after{content:' ';background-color:", ";display:block;position:absolute;top:0;bottom:0;right:0;left:100%;opacity:0;transition:left 0.15s ease-out 0.2s,opacity 5ms linear 0.25s;border-radius:20px 20px 2px 20px;}", ""], ({
  theme
}) => theme.color['do-not-use-sorbet'], ({
  theme
}) => theme.color['do-not-use-sorbet'], ({
  isOpen
}) => isOpen && `
    box-shadow: 0 5px 20px 0 rgba(12, 73, 84, 0);
    &::after {
      transition: left 0.15s ease-out, opacity 5ms linear 0.05s;
      opacity: 1;
      left: 0;
    }
  `);
export default StyledOperationsHubOnboardingButton;